import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { LanguageService } from './language.service';

/**
 * EN / ES switch for the header, built to sit next to the dark-mode toggle and
 * behave the same way: one click, remembered in localStorage, no reload.
 */
@Component({
  selector: 'dhats-language-toggle',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  template: `
    <button
      (click)="language.toggle()"
      mat-stroked-button
      class="theme-switch flex items-center gap-2 group"
      style="min-width: auto; height: 32px; padding: 0 8px; border-radius: 9999px; line-height: 1;"
      [title]="language.isSpanish() ? 'Switch to English' : 'Cambiar a español'"
    >
      <span
        class="text-[10px] font-black tracking-widest transition-opacity"
        [style.opacity]="language.isSpanish() ? '0.3' : '1'"
        style="color: var(--brand-color)"
      >EN</span>

      <span
        class="toggle-track relative inline-flex h-5 w-9 flex-shrink-0 rounded-full border-2 transition-colors duration-200"
        [class.track-dark]="language.isSpanish()"
        [class.track-light]="!language.isSpanish()"
      >
        <span
          class="toggle-thumb pointer-events-none inline-block h-3.5 w-3.5 transform rounded-full shadow transition-transform duration-200"
          [class.translate-x-4]="language.isSpanish()"
          [class.translate-x-0]="!language.isSpanish()"
        ></span>
      </span>

      <span
        class="text-[10px] font-black tracking-widest transition-opacity"
        [style.opacity]="language.isSpanish() ? '1' : '0.3'"
        style="color: var(--brand-color)"
      >ES</span>
    </button>
  `,
})
export class LanguageToggleComponent {
  readonly language = inject(LanguageService);
}
